import {
  API_ADD_BOAT_INFO_ARRESTS,
  API_ADD_BOAT_INFO_DOCS,
  API_ADD_BOAT_INFO_DOCS_DOWNLOAD,
  API_ADD_NEW_BOAT_SPEC_MARK,
  API_DELETE_BOAT_INFO_DOCS,
  API_EDIT_BOAT_INFO_ARRESTS,
  API_EDIT_BOAT_SPEC_MARK,
  API_GET_RAYONS_BY_GOROD_ID,
  MAIN_URL,
  PORT,
} from "../../../constants/constants";
import { fetchWithToken } from "../../../interceptors/fetchInterceptor";
import { getCityByObl, getGorod, getRayon } from "../../../utilities";

const mainInformationLines = {
  keyTable: "mainInformation",
  caption: "Информация об объекте:",
  classNameTable: "primary-table",
  classNameCaption: "primary-caption",
  gridKey: "grid-container-main-info",
  blockVisibility: true,
  inputsOptions: {
    regNum: {
      key: "regNum",
      label: "Регистрацонный номер маломерного судна",
      type: "text",
      needInForm: true,
    },
    boatName: {
      key: "boatName",
      label: "Название маломерного судна",
      type: "text",
      needInForm: true,
      placeholder: "Введите",
      required: true,
    },
    parkingPlace: {
      key: "parkingPlace",
      label: "Местоположение (включая юридический адрес и страну)",
      type: "text",
      needInForm: true,
      placeholder: "Введите",
      required: true,
    },
    boatTypeId: {
      key: "boatTypeId",
      label: "Тип",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    boatVidId: {
      key: "boatVidId",
      label: "Вид",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    boatYear: {
      key: "boatYear",
      label: "Год постройки",
      type: "text",
      needInForm: true,
      placeholder: "Введите",
      required: true,
    },
    boatVin: {
      key: "boatVin",
      label: "Заводской номер",
      type: "text",
      needInForm: true,
      placeholder: "Введите",
      required: true,
    },
    engpwrmax: {
      key: "engpwrmax",
      label: "Предельная мощность двигателей (л.с.)",
      type: "text",
      needInForm: true,
      placeholder: "Введите",
      required: true,
      pattern: {
        value: /^\d+(\.|\,)?\d*$/,
        message: "Для ввода доступны только цифры, точка и запятая",
      },
      dotAutoCorrect: true,
    },
    engineNum: {
      key: "engineNum",
      label: "Количество двигателей",
      type: "text",
      needInForm: true,
      placeholder: "Введите",
      required: true,
    },
    saCategoryId: {
      key: "saCategoryId",
      label: "Категория сложности района плавания",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    tiketNum: {
      key: "tiketNum",
      label: "№ и дата выдачи судового билета (в том числе дубликата судового билета)",
      type: "text",
      needInForm: true,
      placeholder: "Введите",
      required: true,
    },
  },
};
const ownerInformationColumns = {
  keyTable: "ownerInformation",
  caption: "Сведения о собственнике",
  classNameTable: "secondary-table",
  classNameCaption: "secondary-caption",
  eventKey: "edit",
  editAccessName: "editRkHist",
  editTable: false,
  addNote: false,
  nameProps: {
    ownerType: {
      key: "ownerType",
      value: "Собственник",
    },
    fio: {
      key: "fio",
      value: "Ф.И.О.",
    },
    ownerAddress: {
      key: "ownerAddress",
      value: "Адрес",
    },
    ownerDocType: {
      key: "ownerDocType",
      value: "Сведения о документе, удостоверяющем личность",
    },
    leName: {
      key: "leName",
      value: "Сведения о юридическом лице, ИП",
    },
    phone: {
      key: "phone",
      value: "Номера телефонов для связи",
    },
  },
  optionsForModalWindowIndividual: {
    caption: "Редактировать сведения о собственнике",
    isHistory: true,
    inputs: {
      ownerType: {
        key: "ownerType",
        label: "Собственник",
        type: "text",
        required: false,
        disabled: true,
      },
      surname: {
        key: "surname",
        label: "Фамилия",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        upperCase: true,
      },
      name: {
        key: "name",
        label: "Имя",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        upperCase: true,
      },
      midname: {
        key: "midname",
        label: "Отчество",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        upperCase: true,
      },
      docType: {
        key: "docType",
        label: "Документ",
        type: "selectWithSearch",
        placeholder: "Выберите",
        fieldModeView: false,
        disabled: false,
        isSearchable: false,
        required: true,
        needInForm: true,
        options: [],
      },
      serialOfPassport: {
        key: "serialOfPassport",
        label: "Серия",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        upperCase: true,
        pattern: {
          value: /^[a-zA-Z]{2}$/,
          message: `Введите 2 латинские буквы`,
        },
      },
      numberOfPassport: {
        key: "numberOfPassport",
        label: "Номер",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        maxLength: 7,
        pattern: {
          value: /^[0-9]+[0-9]*$/,
          message: `Введите только цифры`,
        },
      },
      docDateIssue: {
        key: "docDateIssue",
        label: "Дата выдачи",
        type: "date",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        customValidation(value) {
          if (new Date(value) > new Date()) {
            return "Дата не может быть позднее текущей";
          } else if (new Date(value) < new Date("1996-09-26T00:00:00.000+03:00")) {
            return "Дата не может быть ранее 26.09.1996";
          } else {
            return true;
          }
        },
      },
      docDepartment: {
        key: "docDepartment",
        label: "Кем выдан",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        upperCase: true,
      },
      persNum: {
        key: "persNum",
        label: "Идентификационный номер",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        pattern: {
          value: /^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/,
          message: `Введите номер в формате "0000000A000AA0"`,
        },
        customButton: true,
        buttonName: "Найти",
        customIcon: true,
        upperCase: true,
      },
      addressCaption: {
        key: "addressCaption",
        caption: "Адрес места жительства",
        needInForm: false,
      },
      oblId: {
        key: "oblId",
        label: "Область или г.Минск",
        type: "selectWithSearch",
        placeholder: "Выберите",
        fieldModeView: false,
        disabled: false,
        isSearchable: true,
        required: true,
        needInForm: true,
        options: [],
      },
      rayonId: {
        key: "rayonId",
        label: "Район",
        type: "selectWithSearch",
        placeholder: "Выберите",
        fieldModeView: false,
        disabled: true,
        isSearchable: true,
        required: true,
        needInForm: true,
        options: [],
      },
      gorodId: {
        key: "gorodId",
        label: "Населённый пункт",
        type: "selectWithSearch",
        placeholder: "Выберите",
        fieldModeView: false,
        disabled: true,
        isSearchable: true,
        required: true,
        needInForm: true,
        options: [],
      },
      ulica: {
        key: "ulica",
        label: "Улица",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: false,
        needInForm: true,
        pattern: {
          value: /^[а-яА-ЯёЁ0-9\s.,;:!?-]*$/,
          message: `Заполнение на русском языке, можно использовать цифры и пробелы`,
        },
        upperCase: true,
      },
      dom: {
        key: "dom",
        label: "Дом",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        pattern: {
          value: /^[^0].*$/,
          message: "Номер дома не может быть 0 или начинаться с 0",
        },
        upperCase: true,
      },
      korpus: {
        key: "korpus",
        label: "Корпус",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: false,
        needInForm: true,
        upperCase: true,
      },
      kv: {
        key: "kv",
        label: "Квартира",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: false,
        needInForm: true,
        upperCase: true,
      },
      phone: {
        key: "phone",
        label: "Телефон",
        type: "text",
        placeholder: "+375 (29) ___-__-__",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        pattern: {
          value: /^[0-9+\s,;()-]*$/,
          message: `Недопустимые символы: введите цифры, (), -, +`,
        },
      },
    },
  },
  optionsForModalWindowEntity: {
    caption: "Редактировать сведения о собственнике",
    isHistory: true,
    inputs: {
      ownerType: {
        key: "ownerType",
        label: "Собственник",
        type: "text",
        required: false,
        disabled: true,
      },
      nameLe: {
        key: "nameLe",
        label: "Наименование юридического лица",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        upperCase: true,
      },
      docDepartmentLe: {
        key: "docDepartmentLe",
        label: "Наименование гос. организации, осуществляющей регистрацию",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        upperCase: true,
      },
      egrNum: {
        key: "egrNum",
        label: "Единый  ЕГРЮЛиИП",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        maxLength: 9,
        pattern: {
          value: /^[0-9]+[0-9]*$/,
          message: `Введите только цифры`,
        },
      },
      unp: {
        key: "unp",
        label: "УНП",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        maxLength: 9,
        pattern: {
          value: /^[0-9]+[0-9]*$/,
          message: `Введите только цифры`,
        },
        customButton: true,
        buttonName: "Найти",
        customIcon: true,
        buttonDisabled: false,
      },
      addressCaption: {
        key: "addressCaption",
        caption: "Адрес места жительства",
        needInForm: false,
      },
      oblId: {
        key: "oblId",
        label: "Область или г.Минск",
        type: "selectWithSearch",
        placeholder: "Выберите",
        fieldModeView: false,
        disabled: false,
        isSearchable: true,
        required: true,
        needInForm: true,
        options: [],
      },
      rayonId: {
        key: "rayonId",
        label: "Район",
        type: "selectWithSearch",
        placeholder: "Выберите",
        fieldModeView: false,
        disabled: true,
        isSearchable: true,
        required: true,
        needInForm: true,
        options: [],
      },
      gorodId: {
        key: "gorodId",
        label: "Населённый пункт",
        type: "selectWithSearch",
        placeholder: "Выберите",
        fieldModeView: false,
        disabled: true,
        isSearchable: true,
        required: true,
        needInForm: true,
        options: [],
      },
      ulica: {
        key: "ulica",
        label: "Улица",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: false,
        needInForm: true,
        pattern: {
          value: /^[а-яА-ЯёЁ0-9\s.,;:!?-]*$/,
          message: `Заполнение на русском языке, можно использовать цифры и пробелы`,
        },
        upperCase: true,
      },
      dom: {
        key: "dom",
        label: "Дом",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        pattern: {
          value: /^[^0].*$/,
          message: "Номер дома не может быть 0 или начинаться с 0",
        },
        upperCase: true,
      },
      korpus: {
        key: "korpus",
        label: "Корпус",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: false,
        needInForm: true,
        upperCase: true,
      },
      kv: {
        key: "kv",
        label: "Квартира",
        type: "text",
        placeholder: "Введите",
        fieldModeView: false,
        disabled: false,
        required: false,
        needInForm: true,
        upperCase: true,
      },
      phone: {
        key: "phone",
        label: "Телефон",
        type: "text",
        placeholder: "+375 (29) ___-__-__",
        fieldModeView: false,
        disabled: false,
        required: true,
        needInForm: true,
        pattern: {
          value: /^[0-9+\s,;()-]*$/,
          message: `Недопустимые символы: введите цифры, (), -, +`,
        },
      },
    },
  },
};
const additionalInformationInputs = {
  // keyTable: "additionalInformation",
  // caption: "Иные сведения",
  // classNameTable: "additional-information",
  // classNameCaption: "secondary-caption",
  // blockVisibility: true,
  // inputsOptions: {
  //   note: {
  //     key: "note",
  //     value: "Хоз. ведение/оперативное управление",
  //     type: "textarea",
  //     needInForm: true,
  //   },
  //   note2: {
  //     key: "note2",
  //     value: "Аренда/лизинг",
  //     type: "textarea",
  //     needInForm: true,
  //   },
  // },

  keyTable: "additionalInformation",
  caption: "Иные сведения",
  classNameTable: "primary-table",
  classNameCaption: "secondary-caption",
  gridKey: "grid-container-additional-info",
  blockVisibility: true,
  inputsOptions: {
    note: {
      key: "note",
      label: "Хоз. ведение/оперативное управление",
      type: "text",
      placeholder: "Введите",
      textarea: true,
      needInForm: true,
    },
    note2: {
      key: "note2",
      label: "Аренда/лизинг",
      type: "text",
      placeholder: "Введите",
      textarea: true,
      needInForm: true,
    },
  },
};
const boatDimensionsColumns = {
  keyTable: "boatDimensions",
  caption: "Размерения судна",
  classNameTable: "secondary-table",
  classNameCaption: "secondary-caption",
  classQuantityColumns: "columns-vessel-dimensions",
  eventKey: "edit",
  editAccessName: "editRkHist",
  editTable: false,
  addNote: false,
  nameProps: {
    boatLength: {
      key: "boatLength",
      value: "Длина (м)",
    },
    boatWidth: {
      key: "boatWidth",
      value: "Ширина (м)",
    },
    boatHeight: {
      key: "boatHeight",
      value: "Высота борта (м)",
    },
    bodyMaterialName: {
      key: "bodyMaterialName",
      value: "Материал корпуса",
    },
    boatPayload: {
      key: "boatPayload",
      value: "Грузоподъёмность (кг)",
    },
    passengersNum: {
      key: "passengersNum",
      value: "Вместимость пассажиров",
    },
  },
  optionsForModalWindow: {
    caption: "Редактировать размерения судна",
    isHistory: true,
    inputs: {
      boatLength: {
        key: "boatLength",
        label: "Длина (м)",
        type: "text",
        required: true,
        disabled: false,
        dotAutoCorrect: true,
      },
      boatWidth: {
        key: "boatWidth",
        label: "Ширина (м)",
        type: "text",
        required: true,
        disabled: false,
        dotAutoCorrect: true,
      },
      boatHeight: {
        key: "boatHeight",
        label: "Высота борта (м)",
        type: "text",
        required: true,
        disabled: false,
        dotAutoCorrect: true,
      },
      bodyMaterial: {
        key: "bodyMaterial",
        label: "Материал корпуса",
        type: "selectWithSearch",
        placeholder: "Выберите",
        fieldModeView: false,
        disabled: false,
        isSearchable: true,
        required: true,
        needInForm: true,
        options: [],
      },
      boatPayload: {
        key: "boatPayload",
        label: "Грузоподъёмность (кг)",
        type: "text",
        required: true,
        disabled: false,
        dotAutoCorrect: true,
      },
      passengersNum: {
        key: "passengersNum",
        label: "Вместимость пассажиров",
        type: "text",
        required: true,
        disabled: false,
      },
    },
  },
};

const boatToInformationsColumns = {
  keyTable: "boatToInformations",
  caption: "Информация о прохождении технического освидетельствования",
  classNameTable: "secondary-table",
  classNameCaption: "secondary-caption",
  editTable: false,
  addNote: false,
  nameProps: {
    toDate: {
      key: "toDate",
      value: "Дата",
    },
    name: {
      key: "name",
      value: "Должностное лицо, проводившее ТО (Ф.И.О.)",
    },
    result: {
      key: "result",
      value: "Годное/негодное",
    },
    validateMonths: {
      key: "validateMonths",
      value: "Cрок действия",
    },
    actDate: {
      key: "actDate",
      value: "Дата ТО маломерного судна при признании его негодным (запрещенным к эксплуатации)",
    },
  },
};
const outboardEnginesColumns = {
  keyTable: "enginesList",
  caption: "Подвесные двигатели",
  classNameTable: "secondary-table",
  classNameCaption: "secondary-caption",
  classQuantityColumns: "columns-engines",
  eventKey: "edit",
  editAccessName: "editRkHist",
  editTable: false,
  addNote: false,
  nameProps: {
    engname: {
      key: "engname",
      value: "Название (марка)",
    },
    engvin: {
      key: "engvin",
      value: window.innerWidth < 1551 ? "Заводской (идент. номер)" : "Заводской (идентификационный номер)",
    },
    engProdYear: {
      key: "engProdYear",
      value: "Год выпуска двигателя",
    },
    engpwr: {
      key: "engpwr",
      value: "Мощность (л.с.)",
    },
    engineTypes: {
      key: "engineTypes",
      value: "Тип двигателя",
    },
    dateReg: {
      key: "dateReg",
      value: "Дата постановки на учет",
      renderField: (data) => {
        return data.dateReg ? data.dateReg.split("-").reverse().join(".") : "";
      },
    },
    dateRegEnd: {
      key: "dateRegEnd",
      value: "Дата снятия с учета",
    },
  },
  optionsForModalWindow: {
    caption: "Редактировать отметку",
    isHistory: true,
    inputs: {
      engname: {
        key: "engname",
        label: "Название (марка)",
        type: "text",
        required: true,
        disabled: false,
      },
      engvin: {
        key: "engvin",
        label: "Заводской (идентификационный номер)",
        type: "text",
        required: false,
        disabled: false,
      },
      engProdYear: {
        key: "engProdYear",
        label: "Год выпуска двигателя",
        type: "text",
        required: false,
        disabled: false,
      },
      engpwr: {
        key: "engpwr",
        label: "Мощность (л.с.)",
        type: "text",
        required: false,
        disabled: false,
      },
      engineTypeId: {
        key: "engineTypeId",
        label: "Тип двигателя",
        type: "selectWithSearch",
        placeholder: "Выберите",
        required: true,
        disabled: false,
        options: [
          { value: 1, label: "Бензиновый", key: "engineTypeId" },
          { value: 2, label: "Электрический", key: "engineTypeId" },
        ],
      },
      dateReg: {
        key: "dateReg",
        label: "Дата постановки на учет",
        type: "date",
        required: true,
        disabled: false,
      },
      dateRegEnd: {
        key: "dateRegEnd",
        label: "Дата снятия с учета",
        type: "date",
        required: false,
        disabled: false,
      },
    },
  },
};

const staticEnginesColumns = {
  keyTable: "staticEngineList",
  caption: "Стационарные двигатели",
  classNameTable: "secondary-table",
  classNameCaption: "secondary-caption",
  eventKey: "edit",
  editAccessName: "editRkHist",
  editTable: false,
  addNote: false,
  nameProps: {
    engnum: {
      key: "engnum",
      value: "Заводской (идентификационный номер)",
    },
    engpwr: {
      key: "engpwr",
      value: "Мощность (л.с.)",
    },
    dateReg: {
      key: "dateReg",
      value: "Дата постановки на учет",
      renderField: (data) => {
        return data.dateReg ? data.dateReg.split("-").reverse().join(".") : "";
      },
    },
    dateRegEnd: {
      key: "dateRegEnd",
      value: "Дата снятия с учета",
      renderField: (data) => {
        return data.dateRegEnd ? data.dateRegEnd.split("-").reverse().join(".") : "";
      },
    },
  },
  optionsForModalWindow: {
    caption: "Редактировать отметку",
    isHistory: true,
    inputs: {
      engnum: {
        key: "engnum",
        label: "Заводской (идентификационный номер)",
        type: "text",
        required: false,
        disabled: false,
      },
      engpwr: {
        key: "engpwr",
        label: "Мощность (л.с.)",
        type: "text",
        required: false,
        disabled: false,
      },
      dateReg: {
        key: "dateReg",
        label: "Дата постановки на учет",
        type: "date",
        required: false,
        disabled: false,
      },
      dateRegEnd: {
        key: "dateRegEnd",
        label: "Дата снятия с учета",
        type: "date",
        required: false,
        disabled: false,
      },
    },
  },
};
const boatOwnersColumns = {
  keyTable: "boatOwners",
  caption: "Хронология владельцев судна",
  classNameTable: "secondary-table",
  classNameCaption: "secondary-caption",
  classQuantityColumns: "columns-vessel-dimensions",
  eventKey: "edit",
  editAccessName: "editRkHist",
  editTable: false,
  addNote: false,
  nameProps: {
    fio: {
      key: "fio",
      value: "ФИО владельца",
    },
    date: {
      key: "date",
      value: "Дата установления права собственности",
    },
  },
  optionsForModalWindow: {
    caption: "Редактировать отметку",
    isHistory: true,
    inputs: {
      fio: {
        key: "fio",
        label: "ФИО владельца",
        type: "text",
        required: true,
        disabled: false,
      },
      date: {
        key: "date",
        label: "Дата установления права собственности",
        type: "date",
        required: true,
        disabled: false,
      },
    },
  },
};
const boatDealsColumns = {
  keyTable: "boatDeals",
  caption: "Сведения о правах собственности",
  classNameTable: "secondary-table",
  classNameCaption: "secondary-caption",
  classQuantityColumns: "columns-vessel-dimensions",
  eventKey: "edit",
  editAccessName: "editRkHist",
  editTable: false,
  addNote: false,
  nameProps: {
    docNum: {
      key: "docNum",
      value: "Номер документа",
    },
    docDate: {
      key: "docDate",
      value: "Дата документа",
      renderField: (data) => {
        return data.docDate ? data.docDate.split("-").reverse().join(".") : "";
      },
    },
    docName: {
      key: "docName",
      value: "Наименование документа",
    },
    note: {
      key: "note",
      value: "Примечание",
    },
  },
  optionsForModalWindow: {
    caption: "Редактировать отметку",
    isHistory: true,
    inputs: {
      docNum: {
        key: "docNum",
        label: "Номер документа",
        type: "text",
        required: false,
        disabled: false,
      },
      docDate: {
        key: "docDate",
        label: "Дата документа",
        type: "date",
        required: false,
        disabled: false,
      },
      docName: {
        key: "docName",
        label: "Наименование документа",
        type: "text",
        required: false,
        disabled: false,
      },
      note: {
        key: "note",
        label: "Примечание",
        type: "text",
        required: false,
        disabled: false,
      },
    },
  },
};
const boatArrestsColumns = {
  keyTable: "boatArrestsDtos",
  caption: "Налагаемые аресты",
  classNameTable: "secondary-table",
  classNameCaption: "secondary-caption",
  editAccessName: "removalOfArrestFromASmallVessel",
  addAccessName: "seizureOfASmallVessel",
  editTable: true,
  addNote: true,
  eventKey: "edit",
  nameProps: {
    onDate: {
      key: "onDate",
      value: "Дата",
    },
    isActiveOn: {
      key: "isActiveOn",
      value: "Признак ареста",
      renderField: (data) => {
        return "Наложен";
      },
    },
    onOrg: {
      key: "onOrg",
      value: "Орган",
    },
    onOfficer: {
      key: "onOfficer",
      value: "Должностное лицо, принявшее решение",
    },
    nameNumDateOfDocON: {
      key: "nameNumDateOfDocON",
      value: "Наименование, номер и дата документа",
      renderField: (data) => {
        return `${data.onDocName} от ${data.onDocDate}`;
      },
    },
    onNote: {
      key: "onNote",
      value: "Примечание",
    },
  },
  namePropsDeactivateArrest: {
    offDate: {
      key: "offDate",
      value: "Дата",
    },
    isActiveOff: {
      key: "isActiveOff",
      value: "Признак ареста",
      renderField: (data) => {
        return "Снят";
      },
    },
    offOrg: {
      key: "offOrg",
      value: "Орган",
    },
    offOfficer: {
      key: "offOfficer",
      value: "Должностное лицо, принявшее решение",
    },
    nameNumDateOfDocOFF: {
      key: "nameNumDateOfDocOFF",
      value: "Наименование, номер и дата документа",
      renderField: (data) => {
        return `${data.offDocName} от ${data.offDocDate}`;
      },
    },
    offNote: {
      key: "offNote",
      value: "Примечание",
    },
  },
  optionsForModalWindow: {
    addType: {
      caption: "Добавить арест",
      urlForAdd: MAIN_URL + PORT + API_ADD_BOAT_INFO_ARRESTS,
      keyModal: "boatArrestsDtos",
      inputs: {
        handWriting: {
          key: "handWriting",
          label: "Рукописный ввод",
          type: "checkbox",
          defaultValue: false,
          required: false,
          disabled: false,
          hidden: true,
        },
        onOfficer: {
          key: "onOfficer",
          label: "Должностное лицо, принявшее решение",
          type: "text",
          required: true,
          disabled: false,
          hidden: false,
          searchable: true,
          options: [],
        },
        // onOfficerSelect: {
        //   key: "onOfficer",
        //   label: "Должностное лицо, принявшее решение",
        //   type: "selectWithSearch",
        //   required: true,
        //   disabled: false,
        //   searchable: true,
        //   options: [],
        //   hidden: true,
        // },
        onDate: {
          key: "onDate",
          label: "Дата",
          type: "date",
          required: true,
          disabled: false,
          customValidation(value) {
            if (new Date(value) > new Date()) {
              return "Дата не может быть позднее текущей";
            } else {
              return true;
            }
          },
        },
        onOrg: {
          key: "onOrg",
          label: "Орган",
          type: "text",
          required: true,
          disabled: false,
        },
        onDocName: {
          key: "onDocName",
          label: "Наименование, номер документа",
          type: "text",
          required: true,
          disabled: false,
        },
        onDocDate: {
          key: "onDocDate",
          label: "Дата документа",
          type: "date",
          required: true,
          disabled: false,
          customValidation(value, data) {
            if (new Date(value) > new Date()) {
              return "Дата не может быть позднее текущей";
            } else if (data.onDate && new Date(value) > new Date(data.onDate)) {
              return "Дата документа не может быть позднее даты наложения ареста";
            } else {
              return true;
            }
          },
        },
        onNote: {
          key: "onNote",
          label: "Примечание",
          type: "text",
          required: false,
          disabled: false,
        },
      },
    },
    editType: {
      caption: "Снять арест",
      urlForEdit: MAIN_URL + PORT + API_EDIT_BOAT_INFO_ARRESTS,
      keyModal: "boatArrestsDtos",
      inputs: {
        handWriting: {
          key: "handWriting",
          label: "Рукописный ввод",
          type: "checkbox",
          defaultValue: false,
          required: false,
          disabled: false,
          hidden: true,
        },
        offOfficer: {
          key: "offOfficer",
          label: "Должностное лицо, принявшее решение",
          type: "text",
          required: true,
          disabled: false,
          hidden: false,
          searchable: true,
          options: [],
        },
        offDate: {
          key: "offDate",
          label: "Дата",
          type: "date",
          required: true,
          disabled: false,
          validateOnSaveOnly: true,
          customValidation(value) {
            if (new Date(value) > new Date()) {
              return "Дата не может быть позднее текущей";
            } else {
              return true;
            }
          },
        },
        offOrg: {
          key: "offOrg",
          label: "Орган",
          type: "text",
          required: true,
          disabled: false,
        },
        offDocName: {
          key: "offDocName",
          label: "Наименование, номер документа",
          type: "text",
          required: true,
          disabled: false,
        },
        offDocDate: {
          key: "offDocDate",
          label: "Дата документа",
          type: "date",
          required: true,
          disabled: false,
          validateOnSaveOnly: true,
          customValidation(value, data) {
            if (new Date(value) > new Date()) {
              return "Дата не может быть позднее текущей";
            } else if (data.offDate && new Date(value) > new Date(data.offDate)) {
              return "Дата документа не может быть позднее даты снятия ареста";
            } else {
              return true;
            }
          },
        },
        offNote: {
          key: "offNote",
          label: "Примечание",
          type: "text",
          required: false,
          disabled: false,
        },
      },
    },
  },
};

const boatActionsColumns = {
  keyTable: "boatActions",
  caption: "Отметки о внесении изменений в судовую книгу",
  classNameTable: "secondary-table",
  classNameCaption: "secondary-caption",
  editTable: false,
  addNote: false,
  nameProps: {
    actDate: {
      key: "actDate",
      value: "Дата",
    },
    actOrg: {
      key: "actOrg",
      value: "Орган",
    },
    inspector: {
      key: "inspector",
      value: "Должностное лицо, внесшее изменение",
    },
    actNote: {
      key: "actNote",
      value: "Какой раздел редактировался",
    },
  },
};
const notesShipsBookColumns = {
  keyTable: "notesShipsBook",
  caption: "Отметки о внесении судна в судовую книгу / исключении судна из судовой книги",
  classNameTable: "secondary-table",
  classNameCaption: "secondary-caption",
  eventKey: "edit",
  editAccessName: "editRkHist",
  editTable: false,
  nameProps: {
    cardDate: {
      key: "cardDate",
      value: "Дата внесения в судовую книгу",
    },
    cardDateEnd: {
      key: "cardDateEnd",
      value: "Дата исключения из судовой книги",
    },
  },
  optionsForModalWindow: {
    caption: "Редактировать отметку",
    isHistory: true,
    inputs: {
      bsmDate: {
        key: "cardDate",
        label: "Дата внесения в судовую книгу",
        type: "date",
        required: true,
        disabled: false,
      },
      bsmNote: {
        key: "cardDateEnd",
        label: "Дата исключения из судовой книги",
        type: "date",
        required: false,
        disabled: false,
      },
    },
  },
};
const boatCardSpecmarksDtoList = {
  keyTable: "boatCardSpecmarksDtoList",
  caption: "Особые отметки",
  classNameTable: "secondary-table",
  classNameCaption: "secondary-caption",
  editAccessName: "removalOfRestrictionsOnRegistrationActionsWithAVessel",
  addAccessName: "addingRestrictionsOnRegistrationActionsWithAVessel",
  editTable: true,
  addNote: true,
  eventKey: "edit",
  nameProps: {
    bsmLock: {
      key: "bsmLock",
      value: "Ограничение на рег. действия",
      type: "checkbox",
    },
    bsmDate: {
      key: "bsmDate",
      value: "Дата",
    },
    bsmNote: {
      key: "bsmNote",
      value: "Отметка",
    },
  },
  optionsForModalWindow: {
    caption: "Добавить отметку",
    urlForAdd: MAIN_URL + PORT + API_ADD_NEW_BOAT_SPEC_MARK,
    urlForEdit: MAIN_URL + PORT + API_EDIT_BOAT_SPEC_MARK,
    isFile: false,
    inputs: {
      bsmLock: {
        key: "bsmLock",
        label: "Ограничение на рег. действия",
        type: "checkbox",
        defaultValue: false,
        required: false,
        disabled: false,
      },
      bsmDate: {
        key: "bsmDate",
        label: "Дата",
        type: "date",
        required: true,
        disabled: false,
      },
      bsmNote: {
        key: "bsmNote",
        label: "Отметка",
        type: "text",
        required: true,
        disabled: false,
      },
    },
  },
};
const documentsColumns = {
  keyTable: "documents",
  caption: "Документы",
  classNameTable: "secondary-table",
  classNameCaption: "secondary-caption",
  addAccessName: "addingFiles",
  editAccessName: "addingFiles",
  // deleteUrl: `${MAIN_URL}${PORT}${API_DELETE_BOAT_INFO_DOCS}`,
  // editTable: true,
  addNote: true,
  // eventKey: "delete",
  nameProps: {
    docdate: {
      key: "docdate",
      value: "Дата",
    },
    docname: {
      key: "docname",
      value: "Наименование документа",
      type: "link",
      url: `${MAIN_URL}${PORT}${API_ADD_BOAT_INFO_DOCS_DOWNLOAD}`,
    },
  },
  optionsForModalWindow: {
    caption: "Добавить файл",
    urlForAdd: MAIN_URL + PORT + API_ADD_BOAT_INFO_DOCS,
    isFile: true,
    inputs: {
      file: {
        key: "file",
        label: "Документ",
        type: "file",
        required: true,
        disabled: false,
      },
    },
  },
};
export const setOptionsBoatInfo = (type, props) => {
  switch (type) {
    case "firstInit": {
      boatArrestsColumns.optionsForModalWindow.addType.inputs.onOfficer.options = props;
      boatArrestsColumns.optionsForModalWindow.editType.inputs.offOfficer.options = props.map((el) => {
        return { ...el, key: "offOfficer" };
      });
      break;
    }
    default:
      break;
  }
};

export const getOptionsBoatInfo = (mode, statusOfApp) => {
  Object.entries(mainInformationLines.inputsOptions).forEach(([_, obj]) => {
    if (mode === "edit" && obj.key !== "regNum" && statusOfApp === 2) {
      obj.fieldModeView = false;
    } else {
      obj.fieldModeView = true;
    }
  });

  if (mode === "edit" && statusOfApp === 2) {
    notesShipsBookColumns.editTable = true;
    outboardEnginesColumns.editTable = true;
    staticEnginesColumns.editTable = true;
    boatDimensionsColumns.editTable = true;
    ownerInformationColumns.editTable = true;
    boatDealsColumns.editTable = true;
  } else {
    notesShipsBookColumns.editTable = false;
    outboardEnginesColumns.editTable = false;
    staticEnginesColumns.editTable = false;
    boatDimensionsColumns.editTable = false;
    ownerInformationColumns.editTable = false;
    boatDealsColumns.editTable = false;
  }

  return {
    bodyTable: {
      mainInformation: mainInformationLines,
      ownerInformation: ownerInformationColumns,
      additionalInformation: additionalInformationInputs,
      boatDimensions: boatDimensionsColumns,
      boatToInformations: boatToInformationsColumns,
      outboardEnginesList: outboardEnginesColumns,
      staticEnginesList: staticEnginesColumns,
      boatOwners: boatOwnersColumns,
      boatDeals: boatDealsColumns,
      boatArrestsDtos: boatArrestsColumns,
      boatActions: boatActionsColumns,
      notesShipsBook: notesShipsBookColumns,
      boatCardSpecmarksDtoList: boatCardSpecmarksDtoList,
      documents: documentsColumns,
    },
    footerTable: {},
  };
};

export const getOptionsModalWindowBoatInfo = (type, table, userInfo, data) => {
  switch (table) {
    case boatArrestsColumns.keyTable: {
      if (userInfo) {
        if (userInfo?.note === "concerned") {
          boatArrestsColumns.optionsForModalWindow.addType.inputs.onOfficer.disabled = true;
          boatArrestsColumns.optionsForModalWindow.addType.inputs.onOrg.disabled = true;
          boatArrestsColumns.optionsForModalWindow.editType.inputs.offOfficer.disabled = true;
          boatArrestsColumns.optionsForModalWindow.editType.inputs.offOrg.disabled = true;
          boatArrestsColumns.optionsForModalWindow.addType.inputs.handWriting.hidden = true;
          boatArrestsColumns.optionsForModalWindow.editType.inputs.handWriting.hidden = true;
        } else {
          boatArrestsColumns.optionsForModalWindow.addType.inputs.onOfficer.disabled = false;
          boatArrestsColumns.optionsForModalWindow.addType.inputs.onOrg.disabled = false;
          boatArrestsColumns.optionsForModalWindow.editType.inputs.offOfficer.disabled = false;
          boatArrestsColumns.optionsForModalWindow.editType.inputs.offOrg.disabled = false;
          boatArrestsColumns.optionsForModalWindow.addType.inputs.handWriting.hidden = false;
          boatArrestsColumns.optionsForModalWindow.editType.inputs.handWriting.hidden = false;
        }
        return type === "add"
          ? boatArrestsColumns.optionsForModalWindow.addType
          : boatArrestsColumns.optionsForModalWindow.editType;
      }
      break;
    }
    case boatCardSpecmarksDtoList.keyTable: {
      boatCardSpecmarksDtoList.optionsForModalWindow.caption =
        type === "add" ? "Добавить отметку" : "Редактировать отметку";
      return boatCardSpecmarksDtoList.optionsForModalWindow;
    }
    case notesShipsBookColumns.keyTable: {
      return notesShipsBookColumns.optionsForModalWindow;
    }
    case outboardEnginesColumns.keyTable: {
      return outboardEnginesColumns.optionsForModalWindow;
    }
    case staticEnginesColumns.keyTable: {
      return staticEnginesColumns.optionsForModalWindow;
    }
    case boatDimensionsColumns.keyTable: {
      return boatDimensionsColumns.optionsForModalWindow;
    }
    case ownerInformationColumns.keyTable: {
      return data.ownerTypeId === 1
        ? ownerInformationColumns.optionsForModalWindowIndividual
        : ownerInformationColumns.optionsForModalWindowEntity;
    }
    case documentsColumns.keyTable: {
      documentsColumns.optionsForModalWindow.caption = type === "add" ? "Добавить файл" : "";
      return documentsColumns.optionsForModalWindow;
    }
    case boatOwnersColumns.keyTable: {
      boatOwnersColumns.optionsForModalWindow.caption =
        type === "add" ? "Добавить владельца" : "Редактировать запись";
      return boatOwnersColumns.optionsForModalWindow;
    }
    case boatDealsColumns.keyTable: {
      boatOwnersColumns.optionsForModalWindow.caption =
        type === "add" ? "Добавить запись" : "Редактировать запись";
      return boatDealsColumns.optionsForModalWindow;
    }
    default:
      break;
  }
};

export const toggleHandWritingMode = (value, options) => {
  boatArrestsColumns.optionsForModalWindow.addType.inputs.onOfficer.type = value
    ? "text"
    : "selectWithSearch";
  boatArrestsColumns.optionsForModalWindow.addType.inputs.onOfficer.placeholder = value
    ? "Введите"
    : "Выберите";
  boatArrestsColumns.optionsForModalWindow.editType.inputs.offOfficer.type = value
    ? "text"
    : "selectWithSearch";
  boatArrestsColumns.optionsForModalWindow.editType.inputs.offOfficer.placeholder = value
    ? "Введите"
    : "Выберите";
  return options.inputs.hasOwnProperty("onOfficer")
    ? boatArrestsColumns.optionsForModalWindow.addType
    : boatArrestsColumns.optionsForModalWindow.editType;
};

export function setOptionsForBoat(types, kinds, materials, saCategory) {
  const validTypes = types.map((item) => {
    return { ...item, key: "boatTypeId" };
  });
  const validKinds = kinds.map((item) => {
    return { ...item, key: "boatVidId" };
  });
  const validMaterials = materials.map((item) => {
    return { ...item, key: "bodyMaterial" };
  });
  const validCategory = saCategory.map((item) => {
    return { ...item, key: "saCategoryId" };
  });
  if (mainInformationLines.inputsOptions.boatTypeId.options.length === 0) {
    mainInformationLines.inputsOptions.boatTypeId.options.push(...validTypes);
  }
  if (mainInformationLines.inputsOptions.boatVidId.options.length === 0) {
    mainInformationLines.inputsOptions.boatVidId.options.push(...validKinds);
  }
  if (boatDimensionsColumns.optionsForModalWindow.inputs.bodyMaterial.options.length === 0) {
    boatDimensionsColumns.optionsForModalWindow.inputs.bodyMaterial.options.push(...validMaterials);
  }
  if (mainInformationLines.inputsOptions.saCategoryId.options.length === 0) {
    mainInformationLines.inputsOptions.saCategoryId.options.push(...validCategory);
  }
  // return boatInfo;
}

export function handleAddBtn(key, value) {
  // if (key.hasOwnProperty("addNote")) {
  key.addNote = value;
  // }
  return {
    bodyTable: {
      mainInformation: mainInformationLines,
      ownerInformation: ownerInformationColumns,
      additionalInformation: additionalInformationInputs,
      boatDimensions: boatDimensionsColumns,
      boatToInformations: boatToInformationsColumns,
      outboardEnginesList: outboardEnginesColumns,
      staticEnginesList: staticEnginesColumns,
      boatOwners: boatOwnersColumns,
      boatDeals: boatDealsColumns,
      boatArrestsDtos: boatArrestsColumns,
      boatActions: boatActionsColumns,
      notesShipsBook: notesShipsBookColumns,
      boatCardSpecmarksDtoList: boatCardSpecmarksDtoList,
      documents: documentsColumns,
    },
    footerTable: {},
  };
}

export function setDocOptionsDocumentsFromDictionaries(docLib) {
  if (docLib.length > 0) {
    const validLibInterested = docLib.map((item) => {
      return {
        ...item,
        key: "docType",
      };
    });
    if (ownerInformationColumns.optionsForModalWindowIndividual.inputs.docType.options.length === 0) {
      ownerInformationColumns.optionsForModalWindowIndividual.inputs.docType.options.push(
        ...validLibInterested,
      );
    }
    // return ownerInformationColumns.optionsForModalWindow;
  }
}

export function setOblOptionsFromDictionaries(oblLib) {
  const validLibInterested = oblLib.map((item) => {
    return {
      ...item,
      key: "oblId",
    };
  });

  if (ownerInformationColumns.optionsForModalWindowIndividual.inputs.oblId.options.length === 0) {
    ownerInformationColumns.optionsForModalWindowIndividual.inputs.oblId.options.push(...validLibInterested);
  }
  if (ownerInformationColumns.optionsForModalWindowEntity.inputs.oblId.options.length === 0) {
    ownerInformationColumns.optionsForModalWindowEntity.inputs.oblId.options.push(...validLibInterested);
  }
  // return ownerInformationColumns.optionsForModalWindow;
  // type === 1 ? ownerInformationColumns.optionsForModalWindow : interestedEntity;
}

export async function setAddressOptions(value, key, type) {
  if (type === 1) {
    switch (key) {
      case "oblId": {
        if (Number(value[key]) === 5) {
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.rayonId.options = [];
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.rayonId.disabled = true;
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.rayonId.required = false;
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.gorodId.options = [];
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.gorodId.disabled = true;
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.gorodId.required = false;
          return ownerInformationColumns.optionsForModalWindowIndividual;
        } else {
          const rayons = await getRayon(value[key]);
          const cities = await getCityByObl(value[key]);
          const rayonsValid =
            rayons?.map((item) => {
              item.key = "rayonId";
              return item;
            }) || [];
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.rayonId.options = rayonsValid;
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.rayonId.disabled =
            ownerInformationColumns.optionsForModalWindowIndividual.inputs.rayonId.options.length
              ? false
              : true;
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.rayonId.required = true;
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.gorodId.options = cities;
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.gorodId.disabled = false;
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.gorodId.required = true;

          return ownerInformationColumns.optionsForModalWindowIndividual;
        }
      }
      case "rayonId": {
        if (!value.gorodId) {
          const gorod = await getGorod(value[key]);
          const gorodValid =
            gorod?.map((item) => {
              item.key = "gorodId";
              return item;
            }) || [];
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.gorodId.options = gorodValid;
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.gorodId.disabled =
            ownerInformationColumns.optionsForModalWindowIndividual.inputs.gorodId.options.length
              ? false
              : true;
        }
        return ownerInformationColumns.optionsForModalWindowIndividual;
      }
      case "gorodId": {
        const selectedOptions =
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.gorodId.options.find(
            (item) => value[key] === item.value,
          );
        if (selectedOptions.label.includes("г.")) {
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.rayonId.required = false;
        } else {
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.rayonId.required = true;
        }

        const request = await fetchWithToken(MAIN_URL + PORT + API_GET_RAYONS_BY_GOROD_ID + value[key]);

        if (request.ok) {
          const response = await request.json();
          const rayonsValid =
            response?.map((item) => {
              return {
                value: item.id,
                label: item.name,
                key: "rayonId",
              };
            }) || [];
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.rayonId.options = rayonsValid;
          ownerInformationColumns.optionsForModalWindowIndividual.inputs.rayonId.disabled =
            ownerInformationColumns.optionsForModalWindowIndividual.inputs.rayonId.options.length
              ? false
              : true;
        }
        return ownerInformationColumns.optionsForModalWindowIndividual;
      }
      default:
        return ownerInformationColumns.optionsForModalWindowIndividual;
    }
  } else {
    switch (key) {
      case "oblId": {
        if (Number(value[key]) === 5) {
          ownerInformationColumns.optionsForModalWindowEntity.inputs.rayonId.options = [];
          ownerInformationColumns.optionsForModalWindowEntity.inputs.rayonId.disabled = true;
          ownerInformationColumns.optionsForModalWindowEntity.inputs.rayonId.required = false;
          ownerInformationColumns.optionsForModalWindowEntity.inputs.gorodId.options = [];
          ownerInformationColumns.optionsForModalWindowEntity.inputs.gorodId.disabled = true;
          ownerInformationColumns.optionsForModalWindowEntity.inputs.gorodId.required = false;
          return ownerInformationColumns.optionsForModalWindowEntity;
        } else {
          const rayons = await getRayon(value[key]);
          const cities = await getCityByObl(value[key]);
          const rayonsValid =
            rayons?.map((item) => {
              item.key = "rayonId";
              return item;
            }) || [];
          ownerInformationColumns.optionsForModalWindowEntity.inputs.rayonId.options = rayonsValid;
          ownerInformationColumns.optionsForModalWindowEntity.inputs.rayonId.disabled =
            ownerInformationColumns.optionsForModalWindowEntity.inputs.rayonId.options.length ? false : true;
          ownerInformationColumns.optionsForModalWindowEntity.inputs.rayonId.required = true;
          ownerInformationColumns.optionsForModalWindowEntity.inputs.gorodId.options = cities;
          ownerInformationColumns.optionsForModalWindowEntity.inputs.gorodId.disabled = false;
          ownerInformationColumns.optionsForModalWindowEntity.inputs.gorodId.required = true;

          return ownerInformationColumns.optionsForModalWindowEntity;
        }
      }
      case "rayonId": {
        if (!value.gorodId) {
          const gorod = await getGorod(value[key]);
          const gorodValid =
            gorod?.map((item) => {
              item.key = "gorodId";
              return item;
            }) || [];
          ownerInformationColumns.optionsForModalWindowEntity.inputs.gorodId.options = gorodValid;
          ownerInformationColumns.optionsForModalWindowEntity.inputs.gorodId.disabled =
            ownerInformationColumns.optionsForModalWindowEntity.inputs.gorodId.options.length ? false : true;
        }
        return ownerInformationColumns.optionsForModalWindowEntity;
      }
      case "gorodId": {
        const selectedOptions =
          ownerInformationColumns.optionsForModalWindowEntity.inputs.gorodId.options.find(
            (item) => value[key] === item.value,
          );
        if (selectedOptions.label.includes("г.")) {
          ownerInformationColumns.optionsForModalWindowEntity.inputs.rayonId.required = false;
        } else {
          ownerInformationColumns.optionsForModalWindowEntity.inputs.rayonId.required = true;
        }
        const request = await fetchWithToken(MAIN_URL + PORT + API_GET_RAYONS_BY_GOROD_ID + value[key]);

        if (request.ok) {
          const response = await request.json();
          const rayonsValid =
            response?.map((item) => {
              return {
                value: item.id,
                label: item.name,
                key: "rayonId",
              };
            }) || [];
          ownerInformationColumns.optionsForModalWindowEntity.inputs.rayonId.options = rayonsValid;
          ownerInformationColumns.optionsForModalWindowEntity.inputs.rayonId.disabled =
            ownerInformationColumns.optionsForModalWindowEntity.inputs.rayonId.options.length ? false : true;
        }
        return ownerInformationColumns.optionsForModalWindowEntity;
      }
      default:
        return ownerInformationColumns.optionsForModalWindowEntity;
    }
  }
}

export function setMidnameRequiredByDocType(docType) {
  if (docType === 1 || docType === 4) {
    ownerInformationColumns.optionsForModalWindowIndividual.inputs.midname.required = true;
  } else {
    ownerInformationColumns.optionsForModalWindowIndividual.inputs.midname.required = false;
  }
  return ownerInformationColumns.optionsForModalWindowIndividual;
}
